module.exports = __webpack_public_path__ + "img/10.c49da678.jpg";